import { useSelector, useDispatch } from 'react-redux';
import TreeView from "./TreeView";
import { getRuleById, initializeAuth, getTreeById } from "../../services/apiService";
import { setSelectedRule, setRuleTree } from '../../redux/rulesSlice';
import { useMsal } from "@azure/msal-react";

export const TreeRule = () => {
  const { instance, accounts } = useMsal();
  const { ruleTree } = useSelector(state => state.rules);
  const dispatch = useDispatch();

 const handleItemSelect = async (item) => {
    if (item && item.parentId === -1) {
        dispatch(setRuleTree([]));
        dispatch(setSelectedRule({}));
        await initializeAuth(instance, accounts);
        console.log("Selected RulesetGroup:", item.id);
        const response = await getTreeById(item.id);
        dispatch(setRuleTree(response));      
    }
    else if (item && item.id) {
      await initializeAuth(instance, accounts);
      const rule = await getRuleById(item.id);
      console.log("Selected Rule:", rule);
       dispatch(setSelectedRule(rule));
    }
  };
  return <TreeView data={ruleTree} onItemSelect={(item) => handleItemSelect(item)} />;
};
